import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { BASE_URL_WS } from '@/utils/settings';
import { QuoteStore } from '@/stores';

export interface SocketConnectionProps<T = unknown> {
    quoteToken: string;
    setLineItem: (item: T) => void;
    setConnectedSocket: (isConnected: boolean) => void;
}

function SocketConnection<T>({ quoteToken, setLineItem, setConnectedSocket }: SocketConnectionProps<T>) {
    useEffect(() => {
        const url = `${BASE_URL_WS}/ws/instant-quote/${quoteToken}/`;

        const ws = new ReconnectingWebSocket(url, [], {
            maxRetries: 50,
        });

        ws.onopen = () => {
            setConnectedSocket(true);
        };

        ws.onmessage = message => {
            try {
                const data = JSON.parse(message.data);
                const messageType = data.type || 'unknown';

                if (data.type === 'updated.quote_line_item') {
                    const lineItem = JSON.parse(data.message);
                    QuoteStore.setQuoteLineItem(lineItem);
                }

                if (data.type === 'updated_part') {
                    const lineItem = JSON.parse(data.message);
                    QuoteStore.setQuoteLineItem(lineItem);
                }
            } catch (err) {
                console.error('SocketConnection Error - Message.data content:', message?.data, 'Origin Error:', err);
            }
        };

        ws.onclose = () => {
            setConnectedSocket(false);
        };

        ws.onerror = function () {
            ws.close();
        };

        return () => {
            if (ws) {
                ws.close();
            }
        };
    }, [quoteToken]);

    return null;
}

export default observer(SocketConnection);
